import styled, { css } from "styled-components";
import { CircleCheckIcon } from "ui/common/icons";

export const SuccessfulRegistrationPageRoot = styled.div(
    () => css`
        padding: 0px 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    `,
);

export const SuccessfulRegistrationMessage = styled.div(
    () => css`
        text-align: center;
        p {
            display: inline;
        }
    `,
);

export const CircleCheckIconRoot = styled(CircleCheckIcon)(
    ({ theme }) => css`
        color: ${theme.palette.green[200]};
        width: 65px;
        height: 65px;
        margin-bottom: 12px;
    `,
);
